export const PARTN = {
	PA: "Zz50m1I",
	DUKASA: "iD_cmXA",
	BLS: "szgbqzk",
	C2U: "qrGpLwI",
	EVERMED: "vkHODYE",
	ADORA: "eAIt8fU",
	INST_PHARM_PARENT: "S-7LgMU", // InstantScripts Pharmacy Parent Org
	MEDADVISOR: "wk7USAY",
	CAREZEN: "gR3w4jg",
};

export const BOOTH_PARTNERS = {
	[PARTN.CAREZEN]: "CareZen",
}

export const STATES = {
	VIC: "Victoria",
	NSW: "New South Wales",
	ACT: "Australian Capital Territory",
	QLD: "Queensland",
	NT: "Northern Territory",
	WA: "Western Australia",
	SA: "South Australia",
	TAS: "Tasmania",
};

export const ONEPASS_APPLIES_TO_TREATMENT_PLANS = true;
export const ONEPASS_DISCOUNT_CODE = "op";
export const ONEPASS_FIRST_TIME_CODE = "op-first";
export const PUBLIC_DISCOUNT_KEYS = {
	ONE_PASS: "onePass",
	ONE_PASS_FIRST: "onePassFirst",
};

// precentage of discount for referring a friend
export const REFERRAL_DISCOUNT = 5;
export const DOCID_NODR = "-NMXGoMnCzUVo-XIzLwy";

export const MAX_K10_SCORE = 29; // 30 or higher, and we cannot provide async services; a consult is required

export const SECOND = 1000;

export const JOIN_X_AUSTRALIANS_SPECIFIC = 2_530_326;

export const SHOW_CONSULT_ETA = true;
export const SHOW_CONSULT_BAR = false;

export const PRESCRIPTIONS_ROUTE = "/m/pharm/online/prescription";
export const GENERAL_CONSULTATION_ROUTE = "/m/pharm/DocCons/DocConsCov";
// export const CONDITIONS_PAGES_MAPPING = {
// 	'-NR_wwrgDAWpSCRnQS4u': 'treatment-copd',
// 	'-LJcGNXMyADt_gxi2m-f': 'treatment-cholesterol',
// 	'-LJcNCNA4ONtItNNzXB0': 'treatment-heartburn',
// 	'-LJgjeZExUeqwdPu6EuP': 'treatment-allergies',
// 	'-LJgoXQ-7pafIrsSQXZ7': 'treatment-psoriasis',
// 	'-LJlvQo2RunU9oi9abk5': 'treatment-blood-pressure',
// 	'-LJn8ZK_ufxt8fWpDyl8': 'treatment-pain-inflammation',
// 	'-LJVyeBvRW_BnUCsx0kw': 'treatment-skincare',
// 	'-LJVyR5Pdls_ydzW8sRk': 'treatment-asthma',
// 	'-LJw1ii8QN0d9voiNYi3': 'treatment-eye-disease',
// 	'-LMfGlpF3oP3xgL52d7w': 'treatment-migraines-headaches',
// 	'-LMrOQSVQMBVgUqe3y2A': 'treatment-mental-health',
// 	'-LOJ8nO6CQ9dJLu7lTIo': 'treatment-hayfever',
// 	'-LQ-1WaFZZIdgfFLBsZC': 'treatment-sleep-disorders-disease',
// 	'-LStHA4fgdwARB_sds0x': 'treatment-vitamin-deficiency',
// 	'-LtgfWyrIsquO-71lRp3': 'treatment-blood-clots',
// 	'-LTLTLfVHJG0fyp2GO44': 'treatment-gout',
// 	'-LTmNvHxxWf4NuDd8rMn': 'treatment-diabetes',
// 	'-LTwg2i8tlAHzQp_24d2': 'treatment-travel-infections',
// 	'-LUTBLS-EhdO6PD5Z_Tb': 'treatment-thyroid-disease',
// 	'-LwGrL-z9Tx_cVxQH088': 'treatment-sti',
// 	'-LXa3IJ_uqU-Tc348e1S': 'treatment-urinary-incontinence',
// 	'-M2kr-X-SGFjWTib-pYM': 'treatment-quit-smoking-vaping',
// 	'-M34DQ_Bi2Qs7693U5-H': 'treatment-anaphylaxis',
// 	'-M3OqPH3Ur6-IUIrPV6c': 'treatment-prostate-disease',
// 	'-Mb9Djo698wxjv2kmMq6': 'treatment-morning-after-pill',
// 	'-N9YuK8ZZsDznRtdISNF': 'treatment-cold-flu',
// 	acne: 'treatment-acne',
// 	'cold-sores': 'treatment-herpes',
// 	contraception: 'treatment-contraception',
// 	eczema: 'treatment-eczema',
// 	'erectile-dysfunction': 'treatment-erectile-dysfunction',
// 	hair: 'treatment-hair-loss',
// 	herpes: 'treatment-herpes',
// 	nausea: 'treatment-nausea-morning-sickness',
// 	'premature-ejaculation': 'treatment-premature-ejaculation',
// 	rosacea: 'treatment-rosacea',
// 	uti: 'treatment-urinary-tract-infection',
// 	ibs: 'treatment-irritable-bowel-syndrome',
// }

// export const SPECIFIC_CONDITION_REDIRECTS ={
// 	'-N1fTGgW2ONhP0Zurrnn': 'weight-loss',
// 	hrt : "menopause"
// }

export const FIREBASE_CONF_PROD = {
	apiKey: "AIzaSyCQ4Fub0KXF_DBJirQg3mkgy4v-tGFzyyk",
	// authDomain: "safe-scripts.firebaseapp.com",
	authDomain: "www.instantscripts.com.au",
	databaseURL: "https://safe-scripts.firebaseio.com",
	projectId: "safe-scripts",
	storageBucket: "safe-scripts.appspot.com",
	messagingSenderId: "1077172152896",
	appId: "1:1077172152896:web:abad9f5da68037fa",
	vapid_key: "BIDzAIJ4YKsX_L83QA2nCxq1Z45U78XNV8ivo69eobRd-bSMJkoKZ_1426i6dXPsL17HKGQ7J-MpqEBPSkOg0Ls",
	web_client_id: "1077172152896-fjq028kc6q44vlr2a832gvjv2vk3808u.apps.googleusercontent.com",
};

export const FIREBASE_CONF_DEV = {
	apiKey: "AIzaSyC_QgFI3xsOrjUaVvuFcI0QD15uUWMrIdk",
	authDomain:
		typeof app == "undefined" || ["localhost", "127.0.0.1"].includes(location.hostname)
			? "iscr-dev.firebaseapp.com"
			: location.hostname,
	databaseURL: "https://iscr-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
	projectId: "iscr-dev",
	storageBucket: "iscr-dev.appspot.com",
	messagingSenderId: "167379052692",
	appId: "1:167379052692:web:adb2cb6530ced0e9a8ac81",
	measurementId: "G-JBH7HPSC7T",
	vapid_key: "BEKAyq3jNAFtXprLulpdmSbOcE43MyhFXx9NQV7TsfLf4-G-x16fscCEG5df-t7tn_TOk7RsWPvBxe6GKmctzu4",
	web_client_id: "167379052692-qgejj1tmdmkea6001gegb757hfvnel8e.apps.googleusercontent.com",
};
